'use client';

import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { House, ArrowLeft } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';

export default function NotFound() {
  const router = useRouter();

  return (
    <div className="flex min-h-full w-full flex-col items-center justify-center overflow-hidden px-6 py-10 text-center">
      <div className="motion-stagger relative flex flex-col items-center gap-8">
        {/* Mascot sits above a focused brand glow, bobbing gently */}
        <div className="relative flex items-center justify-center">
          <div
            aria-hidden
            className="pointer-events-none absolute h-[300px] w-[300px] rounded-full bg-ds-brand-subtlest opacity-70 blur-3xl"
          />
          <Image
            src="/assets/ellie-broken.avif"
            alt="Ellie, broken"
            width={512}
            height={512}
            preload
            unoptimized
            className="relative h-auto w-[240px] select-none drop-shadow-xl motion-safe:animate-[float_6s_ease-in-out_infinite]"
          />
        </div>

        <div className="flex flex-col items-center gap-3">
          <span className="rounded-full bg-ds-brand-subtlest px-3 py-1 ds-text-body-xs-semibold text-ds-brand-subtle">
            404 · Page not found
          </span>
          <h1 className="font-perfectly-nineties text-5xl leading-tight text-ds-text-darker text-balance">
            Well, this one is broken.
          </h1>
          <p className="ds-text-body-md-medium max-w-md text-pretty text-ds-text-default">
            The page you&apos;re looking for doesn&apos;t exist or has moved.
            Ellie is just as confused as you are.
          </p>
        </div>

        <div className="flex items-center gap-3">
          <Button onClick={() => router.push('/home')}>
            <House weight="bold" />
            Back to home
          </Button>
          <Button variant="outline" onClick={() => router.back()}>
            <ArrowLeft weight="bold" />
            Go back
          </Button>
        </div>
      </div>
    </div>
  );
}
